import { Formik } from 'formik';

import FormWrapper from '~FormWrapper';
import LinksetField from '~fields/LinksetField';

const WorkstationLinksForm = () => <LinksetField name="links" />;

// TODO: Does this need Formik?
const WorkstationLinks = props => (
  <Formik>
    {formikProps => (
      <FormWrapper
        {...props}
        title="Työasemalinkit"
        hideButtons
        formik={formikProps}
        Component={WorkstationLinksForm}
      />
    )}
  </Formik>
);

export default WorkstationLinks;
